export function StepReferrer({ f, set }) {
  return (
    <div className="space-y-4" data-testid="step-referrer">
      <div><label className="text-caption block mb-2">Your Name</label><input value={f.referrer_name} onChange={(e) => set("referrer_name", e.target.value)} className="w-full border border-slate-300 px-3 py-2.5 outline-none focus:border-[#0A192F]" data-testid="intake-referrer-name" /></div>
      <div><label className="text-caption block mb-2">Email</label><input type="email" value={f.referrer_email} onChange={(e) => set("referrer_email", e.target.value)} className="w-full border border-slate-300 px-3 py-2.5 outline-none focus:border-[#0A192F]" data-testid="intake-referrer-email" /></div>
      <div><label className="text-caption block mb-2">Firm / Organization</label><input value={f.referrer_org} onChange={(e) => set("referrer_org", e.target.value)} className="w-full border border-slate-300 px-3 py-2.5 outline-none focus:border-[#0A192F]" data-testid="intake-referrer-org" /></div>
    </div>
  );
}

export function StepClient({ f, set }) {
  return (
    <div className="space-y-4" data-testid="step-client">
      <div><label className="text-caption block mb-2">Client Name / Identifier</label><input value={f.client_name} onChange={(e) => set("client_name", e.target.value)} className="w-full border border-slate-300 px-3 py-2.5 outline-none focus:border-[#0A192F]" data-testid="intake-client-name" /></div>
      <label className="flex items-center gap-3 cursor-pointer"><input type="checkbox" checked={f.is_veteran} onChange={(e) => set("is_veteran", e.target.checked)} data-testid="intake-is-veteran" /><span className="text-slate-700">Client is a U.S. Veteran</span></label>
    </div>
  );
}

export function StepCase({ f, set }) {
  return (
    <div className="space-y-4" data-testid="step-case">
      <div><label className="text-caption block mb-2">Case Type</label>
        <select value={f.case_type} onChange={(e) => set("case_type", e.target.value)} className="w-full border border-slate-300 px-3 py-2.5 outline-none focus:border-[#0A192F] bg-white" data-testid="intake-case-type">
          <option value="medical_malpractice">Medical Malpractice</option>
          <option value="va_claim">VA Disability / Claim</option>
          <option value="personal_injury">Personal Injury</option>
          <option value="dod_related">DOD-related</option>
          <option value="other">Other</option>
        </select>
      </div>
      <div><label className="text-caption block mb-2">Case Summary</label><textarea rows={6} value={f.summary} onChange={(e) => set("summary", e.target.value)} className="w-full border border-slate-300 px-3 py-2.5 outline-none focus:border-[#0A192F] resize-none" data-testid="intake-summary" /></div>
      <div><label className="text-caption block mb-2">Urgency</label>
        <select value={f.urgency} onChange={(e) => set("urgency", e.target.value)} className="w-full border border-slate-300 px-3 py-2.5 outline-none focus:border-[#0A192F] bg-white" data-testid="intake-urgency">
          <option value="standard">Standard</option><option value="expedited">Expedited</option><option value="critical">Critical / SOL Approaching</option>
        </select>
      </div>
    </div>
  );
}

export function StepConflict({ f, set }) {
  return (
    <div className="space-y-4" data-testid="step-conflict">
      <div className="p-5 bg-[#FFFBEB] border border-[#D97706]/40">
        <div className="text-caption text-[#B45309] mb-2">CONFLICT CHECK</div>
        <p className="text-sm text-slate-700 leading-relaxed">By submitting, you confirm that the parties disclosed above are complete and accurate. We will run a conflict clearance against active engagements before accepting the case.</p>
      </div>
      <label className="flex items-start gap-3 cursor-pointer"><input type="checkbox" checked={f.conflict_confirmed} onChange={(e) => set("conflict_confirmed", e.target.checked)} data-testid="intake-conflict-confirm" /><span className="text-sm text-slate-700">I confirm party names/identifiers above are complete and accurate for conflict clearance.</span></label>
    </div>
  );
}

const REVIEW_ROWS = (f) => [
  ["Referrer", `${f.referrer_name} (${f.referrer_email})`],
  ["Organization", f.referrer_org || "—"],
  ["Client", `${f.client_name}${f.is_veteran ? " · Veteran" : ""}`],
  ["Case Type", f.case_type],
  ["Urgency", f.urgency],
  ["Summary", f.summary.slice(0, 200) + (f.summary.length > 200 ? "…" : "")],
];

export function StepReview({ f }) {
  return (
    <div className="space-y-3" data-testid="step-review">
      <h3 className="font-serif font-bold text-lg text-[#0A192F]">Review & Submit</h3>
      {REVIEW_ROWS(f).map(([k, v]) => (
        <div key={k} className="grid grid-cols-3 gap-4 py-2 border-b border-slate-100">
          <div className="text-caption">{k}</div><div className="col-span-2 text-slate-800 text-sm">{v}</div>
        </div>
      ))}
    </div>
  );
}
